import React from 'react'
import { AgentBrokerCard, AgentHero, Breadcrumb, ClaimStatus, FigureCards, FindAgent, MainHeading, NewsCard, WorkTogether } from '../../components'
import { Container } from 'react-bootstrap'
import './agent.scss'
const Agent = () => {
    const crumbsdata = [
        {label:'Sentry Insurance home',link:'/'},
        {label:'Independent agents and brokers',link:'/for-agents-and-brokers'}
    ]
    const featuredCard = [
        {
            id:1,
            value:'120+',
            unit:'Years in business',
            description:'Sentry and its predecessor companies have offered insurance coverage to businesses like yours for more than 120 years.',
        },
        {
            id:2,
            value:'1992',
            unit:'First year of A+ rating milestone',
            description:'Sentry has earned an A+ AM Best rating every year since 1992',
        },
        {
            id:3,
            value:'50',
            unit:'States',
            description:'Sentry serves business customers throughout the U.S.',
        }
    ]
    const NewsCardData = [
        {
          id: 1,
          title: 'Large deductible workers’ compensation plans',
          description:
            'Large deductible workers’ compensation plans can provide excellent value for large, financially strong businesses. We’ll help you build the right plan.',
          linkUrl: '',
          linkText: 'Learn more >',
        },
        {
          id: 2,
          title: 'Training to meet health and safety standards',
          description:
            'Keeping workers safe on the job is key, and that means providing proper training. We explain the federal regulations and how to meet them.',
          linkUrl: '/',
          linkText: 'Learn more >',
        },
        {
          id: 3,
          title: 'Self-insured workers’ compensation',
          description:
            'If your company chooses self-insurance workers’ compensation, we’ll help you manage risk by providing excess coverage with transparent cost structures.',
          linkUrl: '/',
          linkText: 'Learn more >',
        }
      ];
    return (
        <div className='agesnts_and_broker'>
            <Container>
                <Breadcrumb crumbs={crumbsdata}/>
                <MainHeading title="For agents and brokers" showshare={false} />
                <AgentHero/>
                <AgentBrokerCard/>
                <WorkTogether/>
                <FigureCards data={featuredCard} heading="Experience you can count on" 
                para="Our attention to detail and commitment to personalized care have helped us become one of the nation’s largest and most financially secure mutual insurance groups."/>
                <ClaimStatus/>
                <NewsCard Title="Related resources" CardData={NewsCardData} showNavLink={false} subTitle="PRODUCTS"/>
                <FindAgent/>
            </Container>
        </div>
    )
}

export default Agent;
